<template>
  <el-select
    size="mini"
    multiple
    :filterable="filterable"
    :collapse-tags="collapseTags"
    :loading="mulSelectLoading"
    :disabled="disabled"
    :value="selectedValue"
    placeholder="请选择"
    @input="changeSelect"
  >
    <el-checkbox :value="allSelected" @change="selectAll">全选</el-checkbox>
    <el-option
      v-for="item in selectOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  model: {
    prop: "value", // 对应 props msg
    event: "update",
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    // 选项
    selectOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    // 已选中选项
    mulSelecteds: {
      type: Array,
      default() {
        return [];
      },
    },
    mulSelectLoading: {
      type: Boolean,
      default: false,
    },
    collapseTags: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selectedValue() {
      return this.normalizeValue(this.value);
    },
    allSelected() {
      return this.selectOptions.length > 0 && this.selectedValue.length === this.selectOptions.length;
    },
  },
  methods: {
    normalizeValue(value) {
      const list = Array.isArray(value) ? value : [];
      if (this.selectOptions.length === 0) {
        return [...list];
      }
      const optionValues = this.selectOptions.map((item) => item.value);
      return optionValues.filter((item) => list.includes(item));
    },
    arraysEqual(left = [], right = []) {
      const normalizedLeft = this.normalizeValue(left);
      const normalizedRight = this.normalizeValue(right);
      if (normalizedLeft === normalizedRight) {
        return true;
      }
      if (
        !Array.isArray(normalizedLeft) ||
        !Array.isArray(normalizedRight) ||
        normalizedLeft.length !== normalizedRight.length
      ) {
        return false;
      }
      return normalizedLeft.every((item, index) => item === normalizedRight[index]);
    },
    emitValue(value) {
      const nextValue = this.normalizeValue(value);
      if (this.arraysEqual(nextValue, this.value)) {
        return;
      }
      this.$emit("update", nextValue);
      this.$emit("input", nextValue);
    },
    clear() {
      this.emitValue([]);
    },
    selectAll(checked) {
      const selectedArr = checked ? this.selectOptions.map((item) => item.value) : [];
      this.emitValue(selectedArr);
    },
    changeSelect(val) {
      const nextValue = Array.isArray(val) ? val : [];
      this.emitValue(nextValue);
    },
  },
};
</script>

<style scoped>
.el-checkbox {
  text-align: right;
  width: 90%;
}
</style>
